import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import styled from 'styled-components'

import { ReactBlocks } from 'app/helpers/Blocks'
import { IWPGBlockAttributesCompare } from 'app/helpers/IWPGBlockAttributesCompare'

export interface IAttributes {
  color: string
  className?: string
}

const BackgroundBlock: React.FC<IWPGBlock> = (props) => {
  const { color, className } = props.attrs as IAttributes

  return (
    <ReactBlocks
      innerBlocks={props.innerBlocks}
      render={(blocks) => (
        <BackgroundView $color={color} className={className}>
          {blocks}
        </BackgroundView>
      )}
    />
  )
}

const BackgroundView = styled.div<{ $color: string }>`
  background-color: ${(props) => props.$color};
  width: 100%;
  height: 100%;
`

export default React.memo(BackgroundBlock, IWPGBlockAttributesCompare)
